import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { RouterPathService } from "../../../../core/common/variables/router-path.service";
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { TranslateService } from "../../../common/variables/translate-service";
import { ImagePathService } from "../../../common/variables/image-path.service";
import { trigger, state, style, transition, animate, AnimationBuilder, AnimationPlayer } from '@angular/animations';
import { SC_Input } from "../../../common/input/SC_Input";
import { RoofType } from "../../../common/roof/RoofType";
import { RoofShape } from "../../../common/roof/RoofShape";
import { MountingType } from "../../../common/mountsys/MountingType";
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
  FormArray,
  ValidatorFn
} from '@angular/forms';
import { CommonFormValidator } from "../../../common/services/form-validation.service";
import { GlobalFunctionService } from "../../../common/services/global-function.service";
import * as _ from 'lodash';

@Component({
  selector: 'sen-app-roof-shape',
  templateUrl: './roof-shape.component.html',
  styleUrls: ['./roof-shape.component.scss']
})
export class RoofShapeComponent implements OnInit {
  prevPath: string;
  nextPath: string;
  form: FormGroup;
  roofPlanPath: string;
  aBuildingHeight: any[number] = [7, 10, 18];
  defaultHeightM: number;
  defaultPitch: number;
  adhesiveTap: String[];
  adhesiveTabVisible: boolean;
  allLabels: any[string] = [
    { label: "A", value: SC_Input.a },
    { label: "B", value: SC_Input.b },
    { label: "C", value: SC_Input.c },
    { label: "D", value: SC_Input.d }
  ];
  roofPitchArray: any[number] = [15, 20, 25, 30, 35, 40, 45, 50]
  orientationDataArray = [
    { direction: "S", deg: 0 }, { direction: "SSW", deg: 22.5 }, { direction: "SW", deg: 45 }, { direction: "WSW", deg: 67.5 }, { direction: "W", deg: 90 }
    , { direction: "WNW", deg: 112.5 }, { direction: "NW", deg: 135 }, { direction: "NNW", deg: 157.5 }, { direction: "N", deg: 180 }
    , { direction: "NNO", deg: 202.5 }, { direction: "NO", deg: 225 }, { direction: "ONO", deg: 247.5 }, { direction: "O", deg: 270 }
    , { direction: "OSO", deg: 292.5 }, { direction: "SO", deg: 315 }, { direction: "SSO", deg: 337.5 }
  ]

  roofShapeArray = [
    {
      icon: this.imagePath.ROOF_PULT_64,
      image: this.imagePath.ROOF_PULT,
      measurement: this.allLabels.slice(0, 2),
      value: 'pult',
      type: this.translate.getLng('ROOF_PULT'),
      data: RoofShape.PULT
    },
    {
      icon: this.imagePath.ROOF_SATTEL_64,
      image: this.imagePath.ROOF_SATTEL,
      measurement: this.allLabels.slice(0, 2),
      value: 'sattel',
      type: this.translate.getLng('ROOF_SATTEL'),
      data: RoofShape.SATTEL
    },
    {
      icon: this.imagePath.ROOF_WALM_64,
      image: this.imagePath.ROOF_WALM,
      measurement: this.allLabels.slice(0, 3),
      value: 'walm',
      type: this.translate.getLng('ROOF_WALM'),
      data: RoofShape.WALM
    },
    {
      icon: this.imagePath.ROOF_SCHED_64,
      image: this.imagePath.ROOF_SCHED,
      measurement: this.allLabels.slice(0, 2),
      value: 'sched',
      type: this.translate.getLng('ROOF_SCHED'),
      data: RoofShape.SCHED
    },
    {
      icon: this.imagePath.ROOF_KRUEPPEL_64,
      image: this.imagePath.ROOF_KRUEPPEL,
      measurement: this.allLabels,
      value: 'krueppel',
      type: this.translate.getLng('ROOF_KRUEPPEL'),
      data: RoofShape.KRUEPPELWALM
    },
    {
      icon: this.imagePath.ROOF_MANSARD_64,
      image: this.imagePath.ROOF_MANSARD,
      measurement: [],
      value: 'mansard',
      info: this.translate.getLng('PLEASE_SELECT_SATTEL'),
      type: this.translate.getLng('ROOF_MANSARD'),
      data: RoofShape.MANSARD
    }
  ];

  defaultSelectedRoofShape: any;
  defaultOrientation: any;
  defaultAdhesiveTap = SC_Input.sIDAnsKleBanCol;
  @ViewChild('orientationRoof') elementRef: ElementRef;
  private player: AnimationPlayer;

  constructor(
    private routerPath: RouterPathService,
    public translate: TranslateService,
    private animationBuilder: AnimationBuilder,
    private route: ActivatedRoute,
    public globalF: GlobalFunctionService,
    private router: Router,
    private formBuilder: FormBuilder,
    public imagePath: ImagePathService) {
    this.prevPath = `..${this.routerPath.pathSeperator}${this.routerPath.RPMountingString}`;
    this.nextPath = `..${this.routerPath.pathSeperator}${this.routerPath.RPStructureString}`;
    this.roofPlanPath = `..${this.routerPath.pathSeperator}${this.routerPath.RPPanelString}`;
    this.adhesiveTap = [this.translate.getLng('COLOR_BLACK')]; //, this.translate.getLng('COLOR_BRICK_RED')];
    this.form = this.formBuilder.group({
      roofDimension: this.formBuilder.array([]),
      roofHeight: new FormControl(null)
    })
  }

  ngOnInit(): void {
    this.fetchInput();
  }

  ngAfterViewInit() {
    this.changeOrientation(this.defaultOrientation);
  }

  fetchInput() {
    let h = this.aBuildingHeight.findIndex((x: number) => x == SC_Input.iBuilding);
    this.roofHeight.setValue(this.aBuildingHeight[h]);
    this.setRoofShape(this.roofShapeArray[SC_Input.iRoofShape]);
    this.defaultPitch = SC_Input.iRoofAngle;
    this.adhesiveTabVisible = SC_Input.bInRoof;
    let o = this.orientationDataArray.findIndex((o: any) => o.deg == SC_Input.sRoofOrientationDeg);
    this.defaultOrientation = this.orientationDataArray[o];
    if (SC_Input.iRoofType == RoofType.CORRUGATED || SC_Input.iRoofType == RoofType.TRAPEZOIDAL) {
      this.roofPitchArray = [5, 10, ...this.roofPitchArray];
    }
  }

  checkDimenstion() {
    let d: boolean = false;
    let initial = [SC_Input.a, SC_Input.b, SC_Input.c, SC_Input.d];
    for (let i = 0; i < this.defaultSelectedRoofShape.measurement.length; i++) {
      if (this.defaultSelectedRoofShape.measurement[i].value != initial[i]) {
        d = true;
      }
    }
    return d;
  }

  private rememberInput(): void {
    //roof changed, clear hgroups and fences
    if (SC_Input.iRoofShape != this.defaultSelectedRoofShape.data || this.checkDimenstion()) {
      SC_Input.isPlanAltered = true;
      SC_Input.clearRoof();
    }
    if (SC_Input.iBuilding != this.roofHeight.value) {
      SC_Input.isPlanAltered = true;
    }
    SC_Input.iBuilding = this.roofHeight.value;
    SC_Input.iRoofAngle = this.defaultPitch;
    SC_Input.a = this.roofDimension.controls[0].value;
    SC_Input.b = this.roofDimension.controls[1].value;
    if (this.defaultSelectedRoofShape.measurement[2]) {
      SC_Input.c = this.roofDimension.controls[2].value
    }
    if (this.defaultSelectedRoofShape.measurement[3]) {
      SC_Input.d = this.roofDimension.controls[3].value
    }
    if (SC_Input.sIDAnsKleBanCol != this.defaultAdhesiveTap) {
      SC_Input.isPlanAltered = true;
    }
    if (SC_Input.bInRoof) {
      SC_Input.sIDAnsKleBanCol = this.defaultAdhesiveTap;
    }
    SC_Input.iRoofShape = this.defaultSelectedRoofShape.data;
    SC_Input.sRoofOrientation = this.defaultOrientation.direction;
    SC_Input.sRoofOrientationDeg = this.defaultOrientation.deg;
  }

  setRoofShape(shape: any) {
    this.defaultSelectedRoofShape = shape;
    let fArray = this.roofDimension;
    // fArray.controls = [];
    fArray.setValidators(null);
    if (!shape.measurement.length) {
      this.form.setErrors({ invalidRoof: true });
      this.triggerAlertBox();
      return;
    } else {
      this.form.setErrors(null);
    }

    if (this.defaultSelectedRoofShape.measurement) {
      for (let i = 0; i < this.defaultSelectedRoofShape.measurement.length; i++) {
        if (!this.roofDimension.controls[i]) {
          fArray.push(this.formBuilder.control(this.defaultSelectedRoofShape.measurement[i].value, [Validators.required]));
        }
      }
    }
    if (this.defaultSelectedRoofShape.data == RoofShape.KRUEPPELWALM || this.defaultSelectedRoofShape.data == RoofShape.WALM) {
      fArray.setValidators(CommonFormValidator.checkDimension)
    }
  }

  triggerAlertBox() {
    let dialogRef = this.globalF.openAlertBox(this.translate.getLng('PLEASE_SELECT_SATTEL'), this.translate.getLng('OK'));
    dialogRef.afterClosed().subscribe((color: string) => {
      dialogRef.close();
    });
  }

  get roofDimension(): FormArray {
    return this.form.get('roofDimension') as FormArray;
  }

  get roofHeight(): FormControl {
    return this.form.get('roofHeight') as FormControl;
  }

  changeOrientation(o: any) {
    if (this.player) {
      this.player.destroy();
    }
    if (o.deg - this.defaultOrientation.deg > 180) {
      this.defaultOrientation.deg = 360 + this.defaultOrientation.deg;
    } else if (o.deg - this.defaultOrientation.deg < -180) {
      this.defaultOrientation.deg = this.defaultOrientation.deg - 360;
    }
    let animationFactory;
    animationFactory = this.animationBuilder
      .build([
        style({ transform: `rotate(${this.defaultOrientation.deg}deg)` }),
        animate(500, style({ transform: `rotate(${o.deg}deg)` }))
      ]);
    this.player = animationFactory.create(this.elementRef.nativeElement);
    this.player.play();
    this.defaultOrientation = _.cloneDeep(o);
  }

  navPrev() {
    this.rememberInput();
    this.router.navigate([this.prevPath], { relativeTo: this.route });
  }

  navNext() {
    if (this.form.invalid) {
      return;
    }
    this.rememberInput();
    if (SC_Input.bBeam || (SC_Input.iRoofType == RoofType.TRAPEZOIDAL && SC_Input.iMountingType == MountingType.DIRECT)) {
      this.router.navigate([this.nextPath], { relativeTo: this.route });
    } else {
      this.router.navigate([this.roofPlanPath], { relativeTo: this.route });
    }
  }
}
